import axios from 'axios'
import settings from 'config/settings'

type TrackRefundArgs = {
  orderId: number
  products?: { id: number, quantity: number }[]
}

export const trackRefund = (args: TrackRefundArgs) => axios.post(`${settings.shopUrl}/api/adsTracking/refund`, args)
